import { useRef } from 'react';
import classNames from 'classnames';
import {
  Swiper,
  SwiperSlide,
  SwiperProps
} from 'swiper/react';

import {
  Swiper as SwiperType,
  Autoplay,
  Navigation,
  FreeMode
} from 'swiper';
import 'swiper/css';

import 'swiper/css/navigation';

import './styles.css';

import CardPerson from '../../Molecules/CardPerson';
import Icon from '../../Atoms/Icon';

interface slideProps {
  title: string;
  subtitle: string;
  img: {
    src: string;
  };
}
interface Props {
  slides: slideProps[];
  className?: string;
}

const config: SwiperProps = {
  spaceBetween: 40,
  centeredSlides: true,
  speed: 1500,
  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  watchSlidesProgress: true,
  resizeObserver: true,
  observer: true,
  effect: 'slide',
  direction: 'horizontal',
  loop: true,
  grabCursor: true,
  allowTouchMove: true,
  slidesPerView: 'auto',
  freeMode: true
};

function MarqueeTeam({ slides, className }: Props) {
  const swiperRef = useRef<SwiperType>();
  return (
    <div
      className={classNames([
        'marquee-team relative',
        className
      ])}
    >
      <Swiper
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
        {...config}
        modules={[Autoplay, Navigation, FreeMode]}
      >
        {slides.map((item) => (
          <SwiperSlide
            key={slides.indexOf(item)}
            className="!w-64"
          >
            <CardPerson
              title={item.title}
              subtitle={item.subtitle}
              img={item.img}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <button
        onClick={() => swiperRef.current?.slidePrev()}
        type="button"
        className="absolute top-40 left-0 z-10 p-3 text-4xl text-white"
      >
        <Icon icon="chevron-left" />
      </button>
      <button
        onClick={() => swiperRef.current?.slideNext()}
        type="button"
        className="absolute right-0 top-40 z-10 p-3 text-4xl text-white"
      >
        <Icon icon="chevron-right" />
      </button>
    </div>
  );
}

export default MarqueeTeam;
